<template>
     <div class="container" v-title="'队伍报名'">
         <Navigation-bar 
            v-scrollShadow="roll < titleH && roll"
            :title="categoryH > 0 ? teamName : ''">
         </Navigation-bar>
         <div class="container_content" v-show="pageShow">
             <div id="UpdateTeamPersonnel" v-scroll="roll">
                 <Title :title="teamName" subtitle="修改代表队参赛信息"></Title>
                <div id="category" :style="categoryH > 0 ? {'height':categoryH+'px'} : ''">
                    <div class="category_fixed" ref="category_fixed" :class="{'fixed': categoryH > 0}" v-scrollShadow="categoryH > 0 && roll - titleH">
                        <div class="category_tab">
                            <ul>
                                <li :class="{'active':categoryTebIndex == 0}" @click="setTab(0)">全部</li>
                                <li :class="{'active':categoryTebIndex == 2}">
                                    <div class="SelectGroup_text" :class="{'active': group.Id > 0}" @click="selectShow = true">
                                        <span>运动员</span>
                                        <YD-image v-if="group.Id == 0" :src="selectShow ? 'icon/icon_下拉箭头_灰色_向上' : 'icon/icon_下拉箭头_灰色_向下'"></YD-image>
                                        <YD-image v-else :src="selectShow ? 'icon/icon_下拉箭头_白色_向上' : 'icon/icon_下拉箭头_白色_向下'"></YD-image>
                                    </div>
                                </li>
                                <li :class="{'active':categoryTebIndex == 1}" @click="setTab(1)">其他人员</li>
                            </ul>
                            <div class="doubles" :class="{'select': doublesSelect}" v-if="group.type == 3">
                                <div @click="openDoublesSelect">
                                    <YD-image :src="doublesSelect ? 'icon/icon_管理组合_选中' : 'icon/icon_管理组合'"></YD-image>
                                    <span>队员组合</span>
                                </div>
                                <div class="hint" v-if="isHint" @click.stop>
                                    <span>点击此处为队员分配组合</span>
                                    <YD-image src="icon/icon_组合_关闭" @click.native.stop="colseHint"></YD-image>
                                </div>
                            </div>
                        </div>
                        <div class="category_info">
                            <template v-if="group.type == 3">
                                <div class="info" v-if="!doublesSelect"><span>{{categoryInfo.groupName}}共<i>{{categoryInfo.num}}</i>对组合</span></div>
                                <div class="info" v-else><span>{{categoryInfo.groupName}}共<i>{{member.list.length + noDoublesUser.list.length}}</i>名</span></div>
                            </template>
                            <div class="info" v-else><span>{{categoryInfo.groupName}}共<i>{{categoryInfo.num}}</i>名</span></div>
                            <div class="hint" v-show="categoryInfo.hints.length > 0 && !doublesSelect">
                                <ul>
                                    <li v-for="(item,index) in categoryInfo.hints" :key="index"><div>{{item}}</div></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="group_hint" v-if="categoryTebIndex == 2 && group.rejectReason && !doublesSelect">
                    <div>
                        <YD-image src="icon/icon_提示_红色_2"></YD-image>
                        <span>组委会审核不通过</span>
                    </div>
                    <p>{{group.rejectReason}}</p>
                </div>
                <div class="load_more" :style="loadMore == '无数据'?'padding-top:0.5rem':''" v-show="rests.list.length == 0 && loadMore">
                    <img src="@images/no_data/暂无队员@2x.png" v-show="loadMore == '无数据'">
                    <span v-show="loadMore != '无数据'">{{loadMore}}</span>
                </div>
                <div id="member_list">
                    <ul>
                        <template  v-for="(item,index) in memberList">
                            <li class="doubles_error_hint" :key="'a'+index" v-if="index % 2 == 0 && item.UserInfo.PairRejectReason && !doublesSelect">
                                <div>
                                    <YD-image src="icon/icon_提示_红色_2"></YD-image>
                                    <span>【{{item.doublesNumText}}】组委会审核不通过</span>
                                </div>
                                <p>{{item.UserInfo.PairRejectReason}}</p>
                            </li>
                            <li :key="'b'+index" 
                                @click="doublesSelect ? doublesAddUser(item.UserInfo, item.doublesClassName, item.doublesNum) : lookInfo(index,item,1)"
                                :class="group.type == 3 ? [
                                    item.doublesClassName,
                                    (doublesSelect ? 'select' : { 'doubles_error': [4].includes(item.UserInfo.PairEnrollStatus) && item.UserInfo.PairRejectReason })
                                ] : {
                                    'error': ([4,6].includes(item.IndividualEnrollStatus) || item.ImpeachReason)
                                }"
                            >
                                <div class="member_content">
                                    <div class="member_img">
                                        <img :src="getUserPhoto(item.UserInfo)">
                                    </div>
                                    <div class="member_info">
                                        <div class="member_name">
                                            <span>{{item.UserInfo.Name}}</span>
                                            <template v-if="item.UserInfo.EnrollRoleList && item.UserInfo.EnrollRoleList.length > 0">
                                                <template v-for="(roleItem, roleIndex) in item.UserInfo.EnrollRoleList">
                                                    <i c1 :key="roleIndex" v-if="roleItem.RoleId != item.UserInfo.AthleteRoleId">{{roleItem.RoleName}}</i>
                                                    <i c2 :key="roleIndex" v-else>{{roleItem.RoleName}}</i>
                                                </template>
                                            </template>
                                        </div>
                                        <div class="member_group">
                                            <template v-if="item.UserInfo.EnrollGroupList && item.UserInfo.EnrollGroupList.length > 0">
                                                <template v-for="(groupItem, groupIndex) in item.UserInfo.EnrollGroupList">
                                                    <span :key="'a'+groupIndex" :style="!doublesSelect && groupItem.IsImpeached ? 'color:#FF5F2A' : ''">{{groupItem.GroupInfo.Name}}</span>
                                                    <i :key="'b'+groupIndex" v-if="groupIndex < item.UserInfo.EnrollGroupList.length - 1">|</i>
                                                </template>
                                            </template>
                                            <span v-else>暂无组别</span>
                                        </div>
                                    </div>
                                    <template v-if="!doublesSelect">
                                        <YD-image src="icon/card_delete_灰色" class="delete" @click.stop.native="deleteMember(index,1)"></YD-image>
                                    </template>
                                    <template v-else>
                                        <div class="doubles_select"></div>
                                    </template>
                                    <template v-if="item.doublesNumText">
                                        <div class="doubles_sign">{{item.doublesNumText}}</div>
                                    </template>
                                </div>
                                <div class="member_hint" 
                                    v-if="(item.ImpeachReason || item.IndividualRejectReason) && !doublesSelect">
                                    <div>
                                        <YD-image src="icon/icon_提示_红色_2"></YD-image>
                                        <span v-if="item.ImpeachReason">运动员被举报</span>
                                        <span v-else-if="item.IndividualRejectReason">组委会审核不通过</span>
                                    </div>
                                    <p>{{item.ImpeachReason ? item.ImpeachReason : item.IndividualRejectReason}}</p>
                                </div>
                            </li>
                        </template>
                    </ul>
                    <template v-if="group.type == 3">
                        <div v-show="noDoublesUser.list.length && !doublesSelect">下列队员尚未分配组合</div>
                        <ul v-show="noDoublesUser.list.length">
                            <li 
                                v-for="(item,index) in noDoublesUserList" :key="index" 
                                @click="doublesSelect ? doublesAddUser(item.UserInfo, item.doublesClassName, item.doublesNum) : lookInfo(index,item,3)"  
                                :class="doublesSelect ? [item.doublesClassName, 'select'] : {
                                    'error': ([4,6].includes(item.IndividualEnrollStatus) || item.ImpeachReason)
                                }"
                            >
                                <div class="member_content">
                                    <div class="member_img">
                                        <img :src="getUserPhoto(item.UserInfo)">
                                    </div>
                                    <div class="member_info">
                                        <div class="member_name">
                                            <span>{{item.UserInfo.Name}}</span>
                                            <template v-if="item.UserInfo.EnrollRoleList && item.UserInfo.EnrollRoleList.length">
                                                <template v-for="(roleItem, roleIndex) in item.UserInfo.EnrollRoleList">
                                                    <i c1 :key="roleIndex" v-if="roleItem.RoleId != item.UserInfo.AthleteRoleId">{{roleItem.RoleName}}</i>
                                                    <i c2 :key="roleIndex" v-else>{{roleItem.RoleName}}</i>
                                                </template>
                                            </template>
                                        </div>
                                        <div class="member_group">
                                            <template v-if="item.UserInfo.EnrollGroupList && item.UserInfo.EnrollGroupList.length">
                                                <template v-for="(groupItem, groupIndex) in item.UserInfo.EnrollGroupList">
                                                    <span :key="'a'+groupIndex" :style="!doublesSelect && groupItem.IsImpeached ? 'color:#FF5F2A' : ''">{{groupItem.GroupInfo.Name}}</span>
                                                    <i :key="'b'+groupIndex" v-if="groupIndex < item.UserInfo.EnrollGroupList.length - 1">|</i>
                                                </template>
                                            </template>
                                            <span v-else>暂无组别</span>
                                        </div>
                                    </div>
                                    <template v-if="!doublesSelect">
                                        <YD-image src="icon/card_delete_灰色" class="delete" @click.stop.native="deleteMember(index,3)"></YD-image> 
                                    </template>
                                    <template v-else>
                                        <div class="doubles_select"></div>
                                    </template>
                                    <template v-if="item.doublesNumText">
                                        <div class="doubles_sign">{{item.doublesNumText}}</div>
                                    </template>
                                </div>
                                <div class="member_hint" 
                                    v-if="(item.ImpeachReason || item.IndividualRejectReason) && !doublesSelect">
                                    <div>
                                        <YD-image src="icon/icon_提示_红色_2"></YD-image>
                                        <span v-if="item.ImpeachReason">运动员被举报</span>
                                        <span v-else-if="item.IndividualRejectReason">组委会审核不通过</span>
                                    </div>
                                    <p>{{item.ImpeachReason ? item.ImpeachReason : itemIndividualRejectReason}}</p>
                                </div>
                            </li>
                        </ul>
                    </template>
                    <div v-show="rests.list.length">可加入该组的备选参赛人员</div>
                    <ul v-show="rests.list.length">
                        <li 
                            v-for="(item,index) in restsList" :key="index" 
                            @click="doublesSelect ? doublesAddUser(item.UserInfo, item.doublesClassName, item.doublesNum) : lookInfo(index,item,2)"
                            :class="doublesSelect ? [item.doublesClassName, 'select'] : ''"
                        >
                            <div class="member_content">
                                <div class="member_img">
                                    <img :src="getUserPhoto(item.UserInfo)">
                                </div>
                                <div class="member_info">
                                    <div class="member_name">
                                        <span>{{item.UserInfo.Name}}</span>
                                        <template v-if="item.UserInfo.EnrollRoleList && item.UserInfo.EnrollRoleList.length">
                                            <template v-for="(roleItem, roleIndex) in item.UserInfo.EnrollRoleList">
                                                <i c1 :key="roleIndex" v-if="roleItem.RoleId != item.UserInfo.AthleteRoleId">{{roleItem.RoleName}}</i>
                                                <i c2 :key="roleIndex" v-else>{{roleItem.RoleName}}</i>
                                            </template>
                                        </template>
                                    </div>
                                    <div class="member_group">
                                        <template v-if="item.UserInfo.EnrollGroupList && item.UserInfo.EnrollGroupList.length">
                                            <template v-for="(groupItem, groupIndex) in item.UserInfo.EnrollGroupList">
                                                <span :key="'a'+groupIndex" :style="!doublesSelect && groupItem.IsImpeached ? 'color:#FF5F2A' : ''">{{groupItem.GroupInfo.Name}}</span>
                                                <i :key="'b'+groupIndex" v-if="groupIndex < item.UserInfo.EnrollGroupList.length - 1">|</i>
                                            </template>
                                        </template>
                                        <span v-else>暂无组别</span>
                                    </div>
                                </div>
                                <template v-if="!doublesSelect">
                                    <YD-image src="icon/card_delete_灰色" class="delete" @click.stop.native="deleteMember(index,2)"></YD-image> 
                                </template>
                                <template v-else>
                                    <div class="doubles_select"></div>
                                </template>
                                <template v-if="item.doublesNumText">
                                    <div class="doubles_sign">{{item.doublesNumText}}</div>
                                </template>
                            </div>
                        </li>
                    </ul>
                </div>
             </div>
         </div>
         <div class="bottom_operation" v-show="pageShow && !doublesSelect">
             <button v-href="`/Enroll/AddMember?deputationEnrollId=${deputationEnrollId}&subLeagueId=${subLeagueId}&eventsId=${eventsId}`">新增队员</button>
             <button @click="goSubmit()">完成</button>
         </div>
         <div class="doubles_operation" v-show="doublesSelect">
             <button @click="openDoublesSelect">取消</button>
             <button @click="submitDoubles">确定</button>
         </div>
         <SelectGroup 
            :show.sync="selectShow"
            :groups="group.list"
            :groupId="group.Id" 
            @change="group.Id = $event"
        ></SelectGroup>
         <MemberInfo 
            :show.sync="memberInfo.show" 
            :subLeagueId="subLeagueId"
            :deputationEnrollId="deputationEnrollId"
            :member-info="memberInfo.info"
            :oss-options="UploadOptions"
            @save-success="saveMemberInfo"
        ></MemberInfo>
        <Alert-tip :tipData="alertTip" :tipShow="tipShow" @closeCallback="tipShow = false"  @btnCallback="btnCallback"></Alert-tip>
     </div>
</template>
<script>
import SelectGroup from './components/SelectGroup.vue';
import MemberInfo from './components/MemberInfo.vue';
import {
    convertSize,
    numberToChinese
} from '@js';
import {
    GetMyEnrollDeputationList,//获取报名的代表队
    GetMyEnrollDeputationUserList,//获取代表队人员
    GetMyEnrollDeputationGroupUserList,//获取代表队分组人员
    GetCanJoinGroupUserList,//获取分组可以加入的人员
    GetMyEnrollDeputationGroupList,//获取组别
    GetUserEnrollAllRoleList,//获取所有身份
    DeleteDeputationEnrollUser,//删除参赛人员
    GetAppOwnerDeputationEnrollUploadOptions,
    CheckDeputationEnrollHaveAthleteNoGroup,
    SaveDeputationEnrollDoubles //保存组合
} from '@/api';
export default {
    name:"UpdateTeamPersonnel",
    components:{
        SelectGroup,
        MemberInfo
    },
    data(){
        var deputationEnrollId = parseInt(this.$route.query.deputationEnrollId),
            subLeagueId = parseInt(this.$route.query.subLeagueId),
            type = parseInt(this.$route.query.type), //1无组别用户 2其他人员修改 3组别人员修改
            id = parseInt(this.$route.query.id),//type=1 用户Id, type=3 分组Id
            groupType = parseInt(this.$route.query.groupType);//分组类型
        return{
            subLeagueId: isNaN(subLeagueId) ? 0 : subLeagueId,
            deputationEnrollId: isNaN(deputationEnrollId) ? 0 : deputationEnrollId,
            type: isNaN(type) ? 0 : type,
            id: isNaN(id) ? 0 : id,
            pageShow: false,
            roll:0,
            titleH:0,
            categoryH:0,
            teamName: "",
            teamId: 0,
            eventsId:0,
            categoryTebIndex:0,
            categoryInfo:{
                groupName: "",
                num: 0,
                hints:[],
            },
            isHint:false,
            doublesSelect: false,
            doublesArr:[],
            selectDoublesArr:[],
            doublesIndex:-1,
            roles:[],
            group:{
                list: [],
                Id: 0,
                rejectReason: "",
                enrollStatus: null,
                type: groupType,
                GenderLimit: 0
            },
            selectShow: false,
            member:{
                list:[],
                deleteIndex: -1
            },
            rests:{
                list:[],
                deleteIndex: -1
            },
            noDoublesUser:{
                list:[],
                deleteIndex: -1
            },
            optionType: 1,
            memberInfo:{
                show:false,
                info: {},
                updateIndex: 0
            },
            loadMore:"",
            alertTip:{},
            tipShow:false,
            UploadOptions:{}
        }
    },
    created(){
        this.getDeputationList();
        this.getGroupList();
        this.getRoleList();
        GetAppOwnerDeputationEnrollUploadOptions({
            DeputationEnrollId: this.deputationEnrollId
        }).then(data=>{
            if(data.Code == 0){
                this.UploadOptions = data.UploadOptions;
            }
        })
        if(this.type == 2){
            this.categoryTebIndex = 1;
            this.getUserList(2);
        }else if(this.type == 3){
            this.group.Id = this.id;
        }else{
            this.getUserList(0);
        }
        if(!localStorage.getItem('doubles_select_hint')){
            this.isHint = true;
        }
    },
    mounted(){
        this.titleH = convertSize(1.88);
    },
    activated(){
        this.roll -= 0.001;
        //添加队员成功
        if(sessionStorage.getItem('addMember')){
            sessionStorage.removeItem('addMember');
            this.saveMemberInfo();
        }
        //修改用户手机号成功
        if(sessionStorage.getItem('updatePhone')){
            let list = [],
                index = this.memberInfo.updateIndex;
            if(this.optionType == 1){
                list = this.member.list;
            }else if(this.optionType == 2){
                list = this.rests.list;
            }else if(this.optionType == 3){
                list = this.noDoublesUser.list;
            }
            if(index > -1){
                list[index].UserInfo.Phone = sessionStorage.getItem('updatePhone');
                if(this.optionType == 1){
                    this.$set(this.member,'list',list);
                }else if(this.optionType == 2){
                    this.$set(this.rests,'list',list);
                }else if(this.optionType == 3){
                    this.$set(this.noDoublesUser,'list',list);
                }
            }
            sessionStorage.removeItem('updatePhone');
        }
    },
    computed:{
		portraitUnknown(){
			return require(`@images/portrait_unknown@3x.png`);
		},
		portraitMan(){
			return require(`@images/肖像_男@3x.png`);
		},
		portraitWoman(){
			return require(`@images/肖像_女@3x.png`);
		},
		memberList(){
			let list = [];
			let userList = this.member.list || [];
			if(this.group.type == 3 && userList.length){
				let doublesArr;
				if (this.doublesSelect) {
					doublesArr = this.selectDoublesArr || [];
				} else {
					doublesArr = this.doublesArr || [];
				}
				list = this.setDoublesUserInfo(userList, doublesArr);
			}else{
				list = userList;
			}
			return list;
		},
		restsList(){
			let list = [];
			let userList = this.rests.list || [];
			if(this.group.type == 3 && userList.length){
				let doublesArr;
				if (this.doublesSelect) {
					doublesArr = this.selectDoublesArr || [];
				} else {
					doublesArr = this.doublesArr || [];
				}
				list = this.setDoublesUserInfo(userList, doublesArr);
			}else{
				list = userList;
			}
			return list;
		},
		noDoublesUserList(){
			let list = [];
			let userList = this.noDoublesUser.list || [];
			if(this.group.type == 3 && userList.length){
				let doublesArr;
				if (this.doublesSelect) {
					doublesArr = this.selectDoublesArr || [];
				} else {
					doublesArr = this.doublesArr || [];
				}
				list = this.setDoublesUserInfo(userList, doublesArr);
			}else{
				list = userList;
			}
			return list;
		}
    },
    watch:{
        roll(newVal){
            if(newVal >= this.titleH){
                var categoryH = this.$refs['category_fixed'].offsetHeight;
                this.categoryH = categoryH;
                this.teamShow = false;
            }else{
                this.categoryH = 0;
            }
        },
        'group.Id':{
            deep:true,
            handler(newVal, oldVal){
                if(newVal > 0){
                    this.categoryTebIndex = 2;
                    this.$set(this.rests,'list',[]);
                    this.doublesSelect = false;
                    this.setGroupInfo(newVal);
                    this.getGroupUserList(newVal, oldVal == 0 ? this.group.type : undefined);
                }
            }
        },
        'categoryInfo.hints':{
            deep:true,
            handler(){
                if(this.categoryH > 0){
                    var categoryH = this.$refs['category_fixed'].offsetHeight;
                    this.categoryH = categoryH;
                }
            }
        },
        'doublesSelect':{
            handler(newVal){
                this.$nextTick(function(){
                    if(this.categoryH > 0){
                        var categoryH = this.$refs['category_fixed'].offsetHeight;
                        this.categoryH = categoryH;
                    }
                })
            }
        }
    },
    methods:{
		getUserPhoto(UserInfo){
			if(UserInfo.PhotolUrl){
				return UserInfo.PhotolUrl;
			}else if(UserInfo.Gender == 1){
				return this.portraitMan;
			}else if(UserInfo.Gender == 2){
				return this.portraitWoman;
			}
			return this.portraitUnknown;
		},
        setTab(index){
            if(index != this.categoryTebIndex){
                this.categoryTebIndex = index;
                this.group.Id = 0;
                this.categoryInfo = {
                    groupName: "",
                    num: 0,
                    hints:[]
                };
                this.$set(this.rests,'list',[]);
                this.doublesSelect = false;
                this.group.type = 0;
                let type = index == 0 ? 0 : 2;
                this.getUserList(type);
            }
        },
        //删除队员
        deleteMember(index,type){
            this.optionType = type;
            if(type == 1){
                this.member.deleteIndex = index;
            }else if(type == 2){
                this.rests.deleteIndex = index;
            }else if(type == 3){
                this.noDoublesUser.deleteIndex = index;
            }
            this.alertTip = {
                title:"温馨提示",
                text:"将删除您已添加的参赛人员，请确认操作",
                btnArr:["取消",{
                    text:"删除",
                    style:"color:#7AD21A"
                }]
            },
            this.tipShow = true;
        },
        //查看队员信息
        lookInfo(index,obj,type){
            var info = JSON.parse(JSON.stringify(obj));
            this.optionType = type;
            this.memberInfo.show = true;
            this.memberInfo.info = info.UserInfo;
            this.memberInfo.updateIndex = index;
        },
        btnCallback(text){
            this.tipShow = false;
            if(text == '删除'){
                var memberObj = {},
                    GroupId = 0;
                if(this.optionType == 1){
                    memberObj = this.member;
                    GroupId = this.group.Id;
                } else if(this.optionType == 2){
                    memberObj = this.rests;
                } else if(this.optionType == 3){
                    memberObj = this.noDoublesUser;
                    GroupId = this.group.Id;
                }
                let deleteIndex = memberObj.deleteIndex,
                    list = JSON.parse(JSON.stringify(memberObj.list)),
                    obj = list[deleteIndex];
                this.$Toast('正在删除','loading');
                DeleteDeputationEnrollUser({
                    DeputationEnrollId: this.deputationEnrollId,
                    UserEnrollId: obj.UserInfo.UserEnrollId,
                    GroupId
                }).then(data=>{
                    this.$Toast('hideLoading');
                    if(data.Code == 0){
                        this.$Toast('删除成功','success');
                        this.saveMemberInfo();
                    }
                }).catch(()=>{
                    this.$Toast('hideLoading');
                })
            }else if(text == "继续" || text == "忽略"){
                this.$navigation.back();
            }else if(text == "去操作"){
                if (this.type == 3) { //切换到未组合的双人组别
                    let groupId = this.id;
                    if (this.group.Id == groupId) {
                        this.group.Id == 0;
                    }
                    this.group.Id = groupId;
                } else if (this.type == 1) { //打开没有分配组别的运动员对话框
                    if (this.categoryTebIndex == 0) {
                        this.categoryTebIndex = 3;
                    }
                    this.setTab(0);
                }
            }
        },
        //管理组合
        openDoublesSelect(){
            if(!this.doublesSelect){
                this.selectDoublesArr = JSON.parse(JSON.stringify(this.doublesArr));
                this.doublesIndex = -1;
            }
            if(this.isHint){
                localStorage.setItem('doubles_select_hint',1);
                this.isHint = false;
            }
            this.doublesSelect = !this.doublesSelect;
        },
        colseHint(){
            localStorage.setItem('doubles_select_hint',1);
            this.isHint = false;
        },
        //组合选择
        doublesAddUser({UserEnrollId, Gender}, doublesClassName, doublesNum){
            var arr = JSON.parse(JSON.stringify(this.selectDoublesArr));
            if(doublesClassName == "no-select"){
                let index = this.doublesIndex,
                    GenderLimit = this.group.GenderLimit;
                if(index == -1){
                    arr.push([{
                        id: UserEnrollId,
                        sex: Gender
                    }])
                    this.doublesIndex = arr.length - 1;
                    this.$set(this, 'selectDoublesArr', arr);
                }else{
                    let doublesUsers = arr[index];
                    if(GenderLimit == 4 && doublesUsers[0].sex && Gender && doublesUsers[0].sex == Gender){
                        if(Gender == 1){
                            this.$Toast('请选择一名女队员');
                        }else{
                            this.$Toast('请选择一名男队员');
                        }
                    }else{
                        doublesUsers.push({
                            id: UserEnrollId,
                            sex: Gender
                        })
                        arr[index] = doublesUsers;
                        let doublesIndex = -1;
                        for(var i=0;i<arr.length;i++){
                            if(arr[i].length == 1){
                                doublesIndex = i;
                                break;
                            }
                        }
                        this.doublesIndex = doublesIndex;
                        this.$set(this, 'selectDoublesArr', arr);
                    }
                }
            }else{
                let index = doublesNum - 1;
                let doublesUsers = arr[index];
                if(doublesUsers.length == 1){
                    arr.splice(index,1);
                }else{
                    if(doublesUsers[0].id == UserEnrollId){
                        doublesUsers.splice(0,1);
                    }else if(doublesUsers[1].id == UserEnrollId){
                        doublesUsers.splice(1,1);
                    }
                    arr[index] = doublesUsers;
                }
                this.$set(this, 'selectDoublesArr', arr);
                if(arr.length == 0){
                    this.doublesIndex = -1;
                }else{
                    let doublesIndex = -1;
                    for(var i=0;i<arr.length;i++){
                        if(arr[i].length == 1){
                            doublesIndex = i;
                            break;
                        }
                    }
                    this.doublesIndex = doublesIndex;
                }
            }
        },
        //提交组合
        submitDoubles(){
            var selectDoublesArr = this.selectDoublesArr,
				groupObj = this.group.list.filter(item=>item.GroupSetting.LeagueGroupId == this.group.Id)[0];
            if(this.doublesIndex != -1){
                this.$Toast('请再选择一名队员');
            }else if(selectDoublesArr.length == 0){
                this.$Toast('请选择队员');
            }else if(groupObj.GroupSetting.AthletesMax && groupObj.GroupSetting.AthletesMax < selectDoublesArr.length){
                this.$Toast(`该组别限报${groupObj.GroupSetting.AthletesMax}对`);
            }else{
                let arr = [];
                for(var i=0;i<selectDoublesArr.length;i++){
                    let users = selectDoublesArr[i];
                    arr.push({
                        "UserEnrollId1": users[0].id,
                        "UserEnrollId2": users[1].id,
                        "PairIndex": i + 1
                    })
                }
                this.$Toast('保存中','loading');
                SaveDeputationEnrollDoubles({
                    "DeputationEnrollId": this.deputationEnrollId,
                    "LeagueGroupId": this.group.Id,
                    "DoublesInfo": arr
                }).then(data=>{
                    this.$Toast('hideLoading');
                    if(data.Code == 0){
                        this.$Toast('保存成功','success');
                        this.doublesSelect = false;
                        this.categoryInfo = {
                            groupName: "",
                            num: 0,
                            hints:[]
                        };
                        this.getGroupList();
                        this.getGroupUserList(this.group.Id);
                    }
                }).catch(()=>{
                    this.$Toast('hideLoading');
                })
            }
        },
        //完成
        goSubmit(){
            CheckDeputationEnrollHaveAthleteNoGroup({
                DeputationEnrollId: this.deputationEnrollId
            }).then(data=>{
                if(data.Code == 0 ){
                    if (data.IsDoublesNoPair && data.NoPairGroups) {
                        this.type = 3;
                        this.id = data.NoPairGroups[0].GroupId;
                        let groupName = data.NoPairGroups.length > 1 ?
                                        `“${data.NoPairGroups[0].GroupName}”等${data.NoPairGroups.length}个组别`:
                                        `组别“${data.NoPairGroups[0].GroupName}”`;
                        this.alertTip = {
                            title:"温馨提示",
                            text:`${groupName}尚未进行队员组合操作，现在去操作？`,
                            btnArr:["忽略",{text:"去操作",style:"color:#7AD21A"}]
                        },
                        this.tipShow = true;
                    } else if (data.IsHave && data.NoGroupUsers) {
                        this.type = 1;
                        this.id = data.NoGroupUsers[0].UserId;
                        let userName = data.NoGroupUsers.length > 1 ? 
                                        `“${data.NoGroupUsers[0].Name}”等${data.NoGroupUsers.length}个队员` :
                                        `队员“${data.NoGroupUsers[0].Name}”`;
                        this.alertTip = {
                            title:"温馨提示",
                            text:`${userName}尚未分配组别，现在去分配？`,
                            btnArr:["忽略",{text:"去操作",style:"color:#7AD21A"}]
                        },
                        this.tipShow = true;
                    }else{
                        this.$navigation.back();
                    }
                }
            })
        },
        //获取代表队
        getDeputationList(){
            this.$Toast('正在获取参赛数据','loading');
            GetMyEnrollDeputationList({
                SubLeagueId: this.subLeagueId
            }).then(data=>{
                this.$Toast('hideLoading');
                if(data.Code == 0){
                    this.pageShow = true;
                    var obj = data.EnrollDeputationList.filter(n=>n.DeputationEnrollId == this.deputationEnrollId)[0];
                    this.teamId = obj.DeputationId;
                    this.teamName = obj.DeputationName;
                    this.eventsId = obj.EventsId;
                }
            }).catch(()=>{
                this.$Toast('hideLoading');
            })
        },
        //获取组别
        getGroupList(){
            if(this.deputationEnrollId == 0) return;
            GetMyEnrollDeputationGroupList({
                DeputationEnrollId: this.deputationEnrollId
            }).then(data=>{
                if(data.Code == 0){
                    this.group.list = data.GroupList || [];
                    if(this.group.Id > 0){
                        this.setGroupInfo(this.group.Id);
                    }
                }
            })
        },
        //获取身份
        getRoleList(){
            if(this.deputationEnrollId == 0) return;
            GetUserEnrollAllRoleList({
                DeputationEnrollId: this.deputationEnrollId
            }).then(data=>{
                if(data.Code == 0){
                    this.roles = data.RoleList;
                    this.setRoleInfo();
                }
            })
        },
        //按类型获取参赛人员
        getUserList(type){
            if(this.deputationEnrollId == 0) return;
            this.loadMore = "";
            GetMyEnrollDeputationUserList({
                DeputationEnrollId: this.deputationEnrollId,
                EnrollUserType: type
            }).then(data=>{
                if(data.Code == 0){
                    var EnrollUserList = data.EnrollUserList || [],
                        list = [];
                    //处理与查询分组的数据结构相同
                    EnrollUserList.forEach(item => {
                        list.push({
                            UserInfo: item
                        })
                    });
                    this.member.list = list;
                    this.categoryInfo.num = list.length;
                    this.setRoleInfo();
                    if(list.length == 0){
                        this.loadMore = "无数据";
                    }else if(this.type == 1 && this.id > 0){//审核页面点击分配组别触发
                        let memberInfo = {},
                            index = -1;
                        for(var i=0;i<list.length;i++){
                            if(list[i].UserInfo.UserId == this.id){
                                memberInfo = list[i];
                                index = i;
                                break;
                            }
                        }
                        if(index > -1){
                            this.lookInfo(index, memberInfo, 1);
                        }
                        this.id = 0;
                    }
                }
            })
        },
        //按照组别获取参赛人员
        getGroupUserList(groupId, groupType){
            this.loadMore = "";
            if(!groupType){
                let groupObj = this.group.list.filter(item=>item.GroupSetting.LeagueGroupId == groupId)[0];
                groupType = groupObj.GroupSetting.GroupType;
            }
            GetMyEnrollDeputationGroupUserList({
                DeputationEnrollId: this.deputationEnrollId,
                GroupId: groupId
            }).then(data=>{
                if(data.Code == 0){
                    let GroupUserList = data.GroupUserList || [],
                        GroupDoublesUserList = data.GroupDoublesUserList || [];
                    if(groupType == 3){
                        this.member.list =  GroupDoublesUserList;
                        this.noDoublesUser.list = GroupUserList;
                        if((!GroupUserList || GroupUserList.length == 0) && (!GroupDoublesUserList || GroupDoublesUserList.length == 0)){
                            this.loadMore = "无数据";
                        }
                        if(!GroupDoublesUserList || GroupDoublesUserList.length == 0){
                            this.doublesArr = [];
                        }else{
                            let doublesObj = {},
                                doublesArr = [];
                            for(var i=0;i<GroupDoublesUserList.length;i++){
                                let {UserInfo} = GroupDoublesUserList[i];
                                let arr = doublesObj[UserInfo.PairId] || [];
                                arr.push({
                                    id: UserInfo.UserEnrollId,
                                    sex: UserInfo.Gender
                                })
                                doublesObj[UserInfo.PairId] = arr;
                            }
                            for(var key in doublesObj){
                                doublesArr.push(doublesObj[key]);
                            }
                            this.doublesArr = doublesArr;
                        }
                    }else{
                        this.member.list =  GroupUserList;
                        if(!GroupUserList || GroupUserList.length == 0){
                            this.loadMore = "无数据";
                        }
                    }
                    this.group.rejectReason = data.RejectReason || "";
                }
            })
            //可加入的参赛人员
            GetCanJoinGroupUserList({
                DeputationEnrollId: this.deputationEnrollId,
                GroupId: groupId
            }).then(data=>{
                if(data.Code == 0){
                    var UserList = data.UserList || [],
                        list = [];
                    //处理与查询分组的数据结构相同
                    UserList.forEach(item => {
                        list.push({
                            UserInfo: item
                        })
                    });
                    this.rests.list = list;
                }
            })
        },
        setRoleInfo(){
            if(this.categoryTebIndex == 1){
                let roles = this.roles,
                    hints = [];
                for(var i=0;i<roles.length;i++){
                    let obj = roles[i];
                    if(obj.PeopleMin){
                        if(obj.PeopleMin == 1 && obj.NowEnrollNum == 0){
                            hints.push('依据赛事规程，你需要添加'+obj.RoleName);
                        }else if(obj.PeopleMin > 1 &&  obj.NowEnrollNum < obj.PeopleMin){
                            hints.push('依据赛事规程，你需要添加'+obj.PeopleMin+'名'+obj.RoleName);
                        }
                    }
                }
                this.categoryInfo.hints = hints;
            }
        },
        setGroupInfo(groupId){
            if(this.group.list.length == 0)return;
            let groupObj = this.group.list.filter(item=>item.GroupSetting.LeagueGroupId == groupId)[0];
            let {
                GroupSetting,
                EnrollNum,
                EnrollMaleNum,
                EnrollFemaleNum,
                EnrollDoublesNum,
                EnrollStatus
            } = groupObj;
            let { 
                LeagueGroupId,
                LeagueGroupName,
                AthletesMin,
                AthletesMax,
                MaleAthletesMin,
                MaleAthletesMax,
                FemaleAthletesMin,
                FemaleAthletesMax,
                GroupOrderNo 
            } = GroupSetting;
            let hints = [];
            if(GroupSetting.GroupType == 3){
                if(AthletesMin && EnrollDoublesNum < AthletesMin){
                    hints.push(`该组至少${AthletesMin}对组合才可以参加比赛`);
                }
                if(AthletesMax && EnrollDoublesNum >= AthletesMax){
                    hints.push(`该组别组合对数已满`);
                }
            }else{
                if(AthletesMin && EnrollNum < AthletesMin){
                    hints.push(`该组至少${AthletesMin}名参赛人员才可以参加比赛`);
                }else{
                    if(MaleAthletesMin && EnrollMaleNum < MaleAthletesMin){
                        hints.push(`该组至少${MaleAthletesMin}名男子参赛人员才可以参加比赛`);
                    }
                    if(FemaleAthletesMin && EnrollFemaleNum < FemaleAthletesMin){
                        hints.push(`该组至少${FemaleAthletesMin}名女子参赛人员才可以参加比赛`);
                    }
                }
                if(AthletesMax && EnrollNum >= AthletesMax){
                    hints.push(`该组参赛人员已满`);
                }else{
                    if(MaleAthletesMax && EnrollMaleNum >= MaleAthletesMax){
                        hints.push(`该组男子参赛人员已满`);
                    }
                    if(FemaleAthletesMax && EnrollFemaleNum >= FemaleAthletesMax){
                        hints.push(`该组女子参赛人员已满`);
                    }
                }
            }
            this.group.enrollStatus = EnrollStatus;
            this.group.rejectReason = "";
            this.group.type = GroupSetting.GroupType;
            this.group.GenderLimit = GroupSetting.GenderLimit;
            this.categoryInfo = {
                groupName: LeagueGroupName,
                num: GroupSetting.GroupType == 3 ? EnrollDoublesNum : EnrollNum,
                hints: hints
            };
        },
        saveMemberInfo(){
            this.categoryInfo = {
                groupName: "",
                num: 0,
                hints:[]
            };
            this.$set(this.rests,'list',[]);
            this.getGroupList();
            this.getRoleList();
            if(this.categoryTebIndex == 2){
                this.getGroupUserList(this.group.Id);
            }else{
                this.getUserList(this.categoryTebIndex == 0 ? 0 : 2);
            }
        },
		//标记组合
		setDoublesUserInfo(userList, doublesArr){
			let list = [];
			userList.forEach((item) => {
				let className = "no-select",
					numText = "",
					num = 0;
				for(let i = 0;i < doublesArr.length;i++){
					let doubles = doublesArr[i];
					let isSelect = doubles.some(userItem => userItem.id === item.UserInfo.UserEnrollId);
					let isDouble = doubles.length == 2;
					if(isSelect){
						num = i + 1;
						let num2 = num % 7;
						className = "color-" + (num2 == 0 ? 7 : num2);
						if(isDouble){
							numText = "组合" + numberToChinese(num);
						}
						break;
					}
				}
				list.push({
					...item,
					doublesClassName: className,
					doublesNumText: numText,
					doublesNum: num
				})
			})
			return list;
		}
    }
}
</script>
<style lang="scss" scoped>
@import '@assets/scss/TeamPersonnel.scss';
.group_hint{
    width: calc(100% - 80px);
    height: auto;
    margin: 0 auto;
    margin-bottom: 24px;
    padding: 8px 26px 16px 40px ;
    box-sizing: border-box;
    background: #FEF7F4;
    border-radius: 20px;
    div{
        height: 44px;
        display: flex;
        align-items: center;
        font-size: 26px;
        color: #FF5F2A;
        font-weight: 500;
        img{
            width: 38px;
            height: 38px;
            margin-right: 8px;
        }
    }
    p{
        font-size: 26px;
        color: #F0815C;
        line-height: 40px;
        font-weight: 400;
        margin-top: 4px;
    }
}
</style>